import angular from 'angular'
import vehicleInfoList from './vehicleInfoListComponent'
import vehicleProducingArea from './vehicleProducingAreaComponent'
import vehicleProducer from './vehicleProducerComponent'

import {
    vehicleInfo
} from 'redevConfig'


const list = (vehicleInfo && vehicleInfo.list) || ''

const vehicleInfoTabPage = list ? require(`redevelopment/system/department/${list.templateName}`) : require('./view/vehicleInfoTab.html')

export default angular
    .module('system.basedata.vehicleInfo', [vehicleInfoList, vehicleProducingArea, vehicleProducer])
    .config(['$stateProvider', function config($stateProvider) {
        $stateProvider
            .state('system.basedata.vehicleInfo', {
                abstract: true,
                url: '/vehicleInfo',
                template: '<div ui-view></div>',
                title: '车辆信息',
                default: 'system.basedata.vehicleInfo.list',
            })
            .state('system.basedata.vehicleInfo.list', {
                url: '/list',
                template: vehicleInfoTabPage,
            })
    }])
    .name



// WEBPACK FOOTER //
// ./src/app/system/basedata/vehicleInfo/index.js